export default __webpack_public_path__ + "public/images/home/intro/redStar@2x.png?933a8d17";